import { defaultScrollbarMixin } from 'constants/styles';
import styled from 'styled-components';
import { PrimaryTextParagraph } from 'styles/TextsElements';

export const DetailsDescriptionTextParagraph = styled(PrimaryTextParagraph)`
  ${defaultScrollbarMixin};
`;
